import { ExternalLink } from 'lucide-react'

import { Button, buttonVariants } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

type ViewPublicLinkButtonProps = {
  url: string
  label?: string
  /** Compact icon-only toolbar button with hover tooltip. */
  iconOnly?: boolean
  disabled?: boolean
}

export function ViewPublicLinkButton({
  url,
  label = 'View public page',
  iconOnly = false,
  disabled: disabledProp,
}: ViewPublicLinkButtonProps) {
  const href = url.trim()
  const disabled = disabledProp ?? !href

  if (iconOnly) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {disabled ? (
            <Button
              type="button"
              variant="ghostToolbar"
              size="iconSm"
              disabled
              aria-label={label}
            >
              <ExternalLink className="h-4 w-4" aria-hidden />
            </Button>
          ) : (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className={buttonVariants({ variant: 'ghostToolbar', size: 'iconSm' })}
            >
              <ExternalLink className="h-4 w-4" aria-hidden />
            </a>
          )}
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    )
  }

  return (
    <Button asChild={!disabled} variant="outline" size="sm" disabled={disabled}>
      {disabled ? (
        <>
          <ExternalLink className="h-4 w-4" aria-hidden />
          {label}
        </>
      ) : (
        <a href={href} target="_blank" rel="noopener noreferrer">
          <ExternalLink className="h-4 w-4" aria-hidden />
          {label}
        </a>
      )}
    </Button>
  )
}
